import React from "react";

import Lottie from "lottie-react";
import loaderAnimation from "../../lottieJsons/loader.json";

const FormButton = ({ isSubmitting, buttonText, cw }) => {
  return (
    <button
      className={`bg-[#3e4095] mt-4 min-h-[40px] rounded-md ${
        cw ?? "w-full"
      } text-white flex justify-center items-center relative capitalize`}
      type="submit"
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        <div
          className="absolute top-1/2 left-1/2"
          style={{ transform: "translateX(-50%) translateY(-50%)" }}
        >
          <Lottie
            animationData={loaderAnimation}
            loop={true}
            style={{ width: "60px", height: "60px" }}
          />
        </div>
      ) : (
        buttonText
      )}
    </button>
  );
};

export default FormButton;
